import * as React from 'react';

const CheckSecondaryIcon = props => (
  <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m10 15.171 9.192-9.192 1.415 1.414L10 18l-6.364-6.364 1.414-1.414 4.95 4.95Z" fill="#fff" />
  </svg>
);

export default CheckSecondaryIcon;
